<template>
    <PreLoginForm title="" :logo="false" style="height: 100%">
        <div class="form-content">
            <div class="nova-header">
                <img src="@/assets/img/novakid_logos.png" />
            </div>
            <div style="display: flex; justify-content: center" class="my-4">
                <img src="@/assets/img/novakid_start.png" />
            </div>
            <div class="px-4 mb-6">
                <div class="novakid-label" v-for="label in labels" :key="label">
                    <Checkbox class="mr-4" :readOnly="true" :value="true" />
                    <div v-text="$t(label)" />
                </div>
            </div>
        </div>
        <PreLoginButton
            :label="buttonTitle"
            :loading="loading"
            @click="submit"
            class="login-form-button"
        />
    </PreLoginForm>
</template>
<script>
import PreLoginForm from '@/views/PreLoginView/PreLoginForm'
import PreLoginButton from '@/views/PreLoginView/PreLoginButton'
export default {
    props: { buttonTitle: String },
    components: { PreLoginForm, PreLoginButton },
    data() {
        return {
            loading: false,
            labels: [
                'NOVAKID_LABEL_1',
                'NOVAKID_LABEL_2',
                'NOVAKID_LABEL_3',
                'NOVAKID_LABEL_4'
            ]
        }
    },
    methods: {
        goToForm() {
            const { query } = this.$route
            this.$router.push({
                params: { step: 'email' },
                query
            })
        },
        async submit() {
            try {
                if (this.loading) {
                    return
                }
                this.loading = true
                this.goToForm()
                this.loading = false
            } catch (error) {
                this.goToForm()
                this.loading = false
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.nova-header {
    display: flex;
    align-items: center;

    img {
        width: 100%;
    }
}
.novakid-label {
    display: flex;
    align-items: center;
    font-family: $input-family;
    color: $input;
    margin-bottom: 1rem;
}
.form-content {
    display: flex;
    flex-direction: column;
    overflow-y: auto;
    max-height: 100%;
    margin: -1.5rem;
    margin-bottom: -1rem;
    padding: 1.5rem;
}
</style>
